<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    class="invoiceBillingAddressDialog onDialogBox"
  >
    <div class="formBox">
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="auto"
        :key="formKey"
      >
        <!-- 购买人身份 -->
        <el-form-item :label="$fanyi('购买人身份') + '：'" prop="entity_type">
          <el-radio-group
            v-model="form.entity_type"
            class="entityTypeGroup"
            @change="handleEntityTypeChange"
          >
            <!-- 公司进口商 -->
            <el-radio :label="1">{{ $fanyi("公司进口商") }}</el-radio>
            <!-- 个人 -->
            <el-radio :label="2">{{ $fanyi("个人") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$fanyi('全名') + '：'" prop="contacts">
          <el-input
            size="mini"
            class="uiInput"
            v-model="form.contacts"
            oninput="this.value"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$fanyi('邮编') + '：'" prop="zip_code">
          <el-input
            size="mini"
            class="uiInput"
            v-model="form.zip_code"
            oninput="this.value"
          ></el-input>
        </el-form-item>
        <!-- 城市 -->
        <el-form-item :label="$fanyi('城市') + '：'" prop="city">
          <el-input
            type="textarea"
            class="uiInput"
            v-model="form.city"
            show-word-limit
            resize="none"
            :autosize="{ minRows: 1, maxRows: 12 }"
            oninput="this.value"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$fanyi('省份') + '：'" prop="province">
          <el-input
            type="textarea"
            class="uiInput"
            v-model="form.province"
            show-word-limit
            resize="none"
            :autosize="{ minRows: 1, maxRows: 12 }"
            oninput="this.value"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$fanyi('国家') + '：'" prop="country">
          <el-input
            type="textarea"
            class="uiInput"
            v-model="form.country"
            show-word-limit
            resize="none"
            :autosize="{ minRows: 1, maxRows: 12 }"
            oninput="this.value"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$fanyi('地址') + '：'" prop="address">
          <el-input
            type="textarea"
            class="uiInput"
            v-model="form.address"
            show-word-limit
            resize="none"
            :autosize="{ minRows: 1, maxRows: 12 }"
            oninput="this.value"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$fanyi('电话') + '：'" prop="mobile">
          <el-input
            size="mini"
            class="uiInput"
            v-model="form.mobile"
            oninput="this.value"
          ></el-input>
        </el-form-item>
        <!-- 电子邮件 -->
        <el-form-item :label="$fanyi('电子邮件') + '：'" prop="email">
          <el-input
            size="mini"
            class="uiInput"
            v-model="form.email"
            oninput="this.value"
          ></el-input>
        </el-form-item>
        <template v-if="isCompany">
          <!-- C.F. / Fiscal Code -->
          <el-form-item :label="$fanyi('C.F. / Fiscal Code') + '：'" prop="cnpj">
            <el-input
              size="mini"
              class="uiInput"
              v-model="form.cnpj"
              oninput="this.value"
            ></el-input>
          </el-form-item>
          <!-- P.IVA/VAT NO -->
          <el-form-item
            :label="$fanyi('P.IVA/VAT NO') + '：'"
            prop="vat_number"
          >
            <el-input
              size="mini"
              class="uiInput"
              v-model="form.vat_number"
              oninput="this.value"
            ></el-input>
          </el-form-item>
          <!-- Codice Destinatario SDI -->
          <el-form-item :label="$fanyi('Codice Destinatario SDI') + '：'" prop="sdi">
            <el-input
              size="mini"
              class="uiInput"
              v-model="form.sdi"
              oninput="this.value"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item :label="$fanyi('是否默认') + '：'">
          <el-switch v-model="form.isAcquiescent" class="uiSwitch"> </el-switch>
        </el-form-item>
      </el-form>
      <div class="btn">
        <p v-if="isAdd">
          <el-button
            class="uiBtn uiGreen"
            type="button"
            @click="useraddressAdd"
          >
            {{ $fanyi("新增") }}
          </el-button>
          <el-button class="uiBtn uiFontGreen" type="button" @click="openAdd">
            {{ $fanyi("重置") }}
          </el-button>
        </p>
        <p class="edit" v-else>
          <el-button
            class=" uiBtn uiMintBlue"
            type="button"
            @click="useraddressDelete"
          >
            {{ $fanyi("删除") }}
          </el-button>
          <el-button
            class="uiBtn uiGreen"
            type="button"
            @click="useraddressUpdate"
          >
            {{ $fanyi("保存") }}
          </el-button>
        </p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
// 公司 entity_type
const ENTITY_TYPE_COMPANY = 1;
// 个人 entity_type
const ENTITY_TYPE_INDIVIDUAL = 2;
// 仅公司视图使用的非共用字段
const COMPANY_ONLY_FIELDS = ["vat_number", "cnpj", "sdi"];

export default {
  name: "InvoiceBillingAddressDialog",
  props: {
    addressType: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      dialogVisible: false,
      title: "",
      isAdd: false,
      formKey: "fsddsfa",
      form: {},
    };
  },
  computed: {
    // 是否为公司进口商视图，控制税号类字段显示与校验
    isCompany() {
      return Number(this.form.entity_type) === ENTITY_TYPE_COMPANY;
    },
    // 按购买人身份动态生成校验规则，保存时空字段在输入框下显示「不能为空」
    formRules() {
      const requiredRule = {
        required: true,
        message: this.$fanyi("不能为空"),
        trigger: "blur",
      };
      const rules = {
        entity_type: [requiredRule],
        zip_code: [requiredRule],
        address: [requiredRule],
        contacts: [requiredRule],
        province: [requiredRule],
        // 电话为进口商表单必填项
        mobile: [requiredRule],
        city: [requiredRule],
        country: [requiredRule],
        tel: [requiredRule],
        email: [
          requiredRule,
          {
            type: "email",
            message: this.$fanyi("请输入正确的邮箱地址"),
            trigger: ["blur", "change"],
          },
        ],
      };
      if (this.isCompany) {
        rules.cnpj = [requiredRule];
        rules.vat_number = [requiredRule];
        rules.sdi = [requiredRule];
      }
      return rules;
    },
  },
  methods: {
    // 空表单默认值，新增时默认公司进口商
    emptyForm() {
      return {
        type: this.addressType,
        entity_type: ENTITY_TYPE_COMPANY,
        company: "",
        zip_code: "",
        address: "",
        city: "",
        country: "",
        contacts: "",
        mobile: "",
        tel: "",
        email: "",
        cnpj: "",
        vat_number: "",
        sdi: "",
        mark: "",
        province: "",
        acquiescent: 0,
        isAcquiescent: false,
      };
    },
    // 切换购买人身份：个体户清空税号类字段；任意切换时清除全部校验红框与错误文案
    handleEntityTypeChange(entityType) {
      if (Number(entityType) === ENTITY_TYPE_INDIVIDUAL) {
        COMPANY_ONLY_FIELDS.forEach((field) => {
          this.form[field] = "";
        });
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    // 保存前同步默认地址标记
    syncAcquiescent() {
      this.form.acquiescent = this.form.isAcquiescent ? 1 : 0;
    },
    // 提交前校验表单，未通过时由各字段 rules 在输入框下展示错误
    validateForm() {
      return new Promise((resolve) => {
        if (!this.$refs.form) {
          resolve(false);
          return;
        }
        this.$refs.form.validate((valid) => {
          resolve(valid);
        });
      });
    },
    openAdd() {
      this.dialogVisible = true;
      this.formKey = Math.random()
        .toString(36)
        .slice(-8);
      this.form = this.emptyForm();
      this.isAdd = true;
      this.title = this.$fanyi("新增地址");
    },
    openEdit(item) {
      const data = JSON.parse(JSON.stringify(item));
      data.isAcquiescent = data.acquiescent;
      data.entity_type = data.entity_type
        ? Number(data.entity_type)
        : ENTITY_TYPE_COMPANY;
      if (Number(data.entity_type) === ENTITY_TYPE_INDIVIDUAL) {
        COMPANY_ONLY_FIELDS.forEach((field) => {
          data[field] = "";
        });
      }
      this.form = data;
      this.title = this.$fanyi("编辑地址");
      this.isAdd = false;
      this.dialogVisible = true;
      this.formKey = Math.random()
        .toString(36)
        .slice(-8);
    },
    handleClose(done) {
      // 退出确认：按钮文案走 $fanyi，意大利语取消为 Annulla
      this.$confirm(this.$fanyi("信息未保存，确认退出吗？"), "", {
        confirmButtonText: this.$fanyi("确认"),
        cancelButtonText: this.$fanyi("取消"),
      })
        .then(() => {
          this.form = this.emptyForm();
          done();
        })
        .catch(() => {});
    },
    // 个体户提交前清空税号类字段，避免携带隐藏字段旧值
    prepareSubmitData() {
      if (!this.isCompany) {
        COMPANY_ONLY_FIELDS.forEach((field) => {
          this.form[field] = "";
        });
      }
    },
    async useraddressAdd() {
      this.syncAcquiescent();
      this.prepareSubmitData();
      const valid = await this.validateForm();
      if (!valid) return;
      this.form.tel = "+39 " + this.form.tel;
      this.$api.useraddressAdd(this.form).then((res) => {
        if (res.code != 0)
          return this.$message.error(this.$fun.apiErrorMsg(res.msg));
        this.$message.success(this.$fanyi("保存成功"));
        this.dialogVisible = false;
        this.$emit("success");
      });
    },
    async useraddressUpdate() {
      this.syncAcquiescent();
      this.prepareSubmitData();
      const valid = await this.validateForm();
      if (!valid) return;
      this.form.tel = "+39" + this.form.tel;
      this.$api.useraddressUpdate(this.form).then((res) => {
        if (res.code != 0)
          return this.$message.error(this.$fun.apiErrorMsg(res.msg));
        this.$message.success(this.$fanyi("保存成功"));
        this.dialogVisible = false;
        this.$emit("success");
      });
    },
    useraddressDelete() {
      const msg = this.$fanyi("是否删除当前地址");
      this.$confirm(msg, this.$fanyi("提示"), {
        confirmButtonText: this.$fanyi("确认"),
        cancelButtonText: this.$fanyi("取消"),
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.useraddressDelete({ id: this.form.id }).then((res) => {
            if (res.code != 0)
          return this.$message.error(this.$fun.apiErrorMsg(res.msg));
            this.$message.success(this.$fanyi("保存成功"));
            this.dialogVisible = false;
            this.$emit("success");
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$fanyi("删除取消"),
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../css/mixin";

.entityTypeGroup {
  /deep/ .el-radio {
    margin-right: 24px;
    .el-radio__label {
      font-size: 14px;
      color: #000000;
    }
  }
}

/* 单行 input 固定高度；textarea 根节点为 .el-textarea，勿套 40px 以免与 autosize 内联高度冲突 */
.uiInput.el-input {
  min-height: 40px;
  /deep/ .el-input__inner {
    height: 40px;
    font-size: 14px;
    border-radius: 8px;
    color: #000000;
  }
}

.uiInput.el-textarea {
  min-height: 56px;
  /deep/ .el-textarea__inner {
    min-height: 56px !important;
    font-size: 14px;
    border-radius: 8px;
    color: #000000;
    line-height: 20px;
  }
}

.btn {
  text-align: center;
  .uiBtn {
    border-radius: 12px;
    font-size: 16px;
    line-height: 20px;
    min-width: 120px;
    height: 46px;
  }
  .uiBtn + .uiBtn {
    margin-left: 20px;
  }
}

.formBox {
  padding: 40px;
}
</style>
